<template>
    <div class="select-input__option-list-wrap" v-if="isListVisible && items.length">
        <ul class="select-input__option-list">
            <li class="select-input__option"
                v-for="(item, index) in items"
                :key="index"
                :class="{ 'selected': currentItemIndex === index }"
                @click="clickHandler($event, item)"
                v-html="setOptionalText(item)"
            >
            </li>
        </ul>
    </div>
</template>

<script>

export default {
    name: 'select-input-order',

    props: {
        items: {
            required: true,
        },

        isListVisible: {
            required: false,
        },

        currentItemIndex: {
            required: false,
        },
    },

    methods: {
        clickHandler(evt, item) {
            this.$emit('click', evt, item);
        },

        setOptionalText(item) {
            const name = this.htmlEntityDecode(item.NAME);
            const phone = item.PERSONAL_PHONE ? `, ${this.formatPhone(item.PERSONAL_PHONE)}` : '';

            return name + phone;
        },

        htmlEntityDecode(value) {
            if (!value || typeof value !== 'string') return '';
            const txt = document.createElement('textarea');
            txt.innerHTML = value.replaceAll('&amp;', '&');
            return txt.value;
        },

        formatPhone(phone) {
            const arr = `${phone}`.split('');

            return arr.reduce((prev, curr, index) => {
                switch (index) {
                case 0:
                    return '+7 (';
                case 4:
                    return `${prev}) ${curr}`;
                case 7:
                    return `${prev}-${curr}`;
                case 9:
                    return `${prev}-${curr}`;
                default:
                    return `${prev}${curr}`;
                }
            }, '');
        },
    },
};
</script>
